export default {
    en: {
        CHALLENGE_HEADER_NAVIGATION_BAR_LABEL: 'Header Navigation',
        CHALLENGE_HEADER_TITLE_MAIN: 'CYBERSAFE',
        CHALLENGE_HEADER_TITLE_ACCENT: 'AI',
        CHALLENGE_HEADER_LEVEL_NAME: '{namePrefix} - {nameSuffix}',
        CHALLENGE_HEADER_STARS_ALT: 'Stars',
        CHALLENGE_HEADER_COMPLETE_ALT: 'Mission complete, current score',
        CHALLENGE_HEADER_SCORE_ANNOUNCEMENT: 'Current Score: {n} Star|Current Score: {n} Stars',
        CHALLENGE_LAYOUT_FORM_BUTTONS_SUBMIT: 'Submit',
        CHALLENGE_LAYOUT_F0RM_BUTTONS_BACK: 'Back to Menu',
        CHALLENGE_FORM_DEFAULT_LABEL: 'Your Answer',
        CHALLENGE_FORM_FLAG_LABEL: 'The Secret Flag',
        CHALLENGE_FORM_MULTIPLE_SELECT_VALIDATION_MESSAGE: 'At least one selection is required',
        CHALLENGE_FORM_LOADING_MESSAGE: 'Loading next question...',
        CHALLENGE_BOT_ARTIFACT_LABEL_CAT_GUARD: 'Ask the cat guardian a question',
        CHALLENGE_BOT_ARTIFACT_THINKING: 'Thinking',
        CHALLENGE_BOT_ARTIFACT_THINKING_DONE: 'Done thinking. {message}',
    }
};
